import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { FaPlus, FaTimes } from 'react-icons/fa';
import './CardsPage.css';

const CardsPage = () => {
    const { cards, addCard, removeCard } = useAuth();
    const [showAddForm, setShowAddForm] = useState(false);
    const [newCard, setNewCard] = useState({
        number: '',
        name: '',
        expiry: '',
        cvv: '',
        type: 'visa'
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewCard(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Simple validation
        if (!newCard.number || !newCard.name || !newCard.expiry || !newCard.cvv) {
            alert('Please fill in all fields');
            return;
        }

        // Determine card type based on number (very simple check)
        let type = 'visa'; // Default
        if (newCard.number.startsWith('5')) type = 'mastercard';

        addCard({
            ...newCard,
            type,
            lastFour: newCard.number.slice(-4),
            bank: 'New Bank' // Placeholder
        });

        setShowAddForm(false);
        setNewCard({ number: '', name: '', expiry: '', cvv: '', type: 'visa' });
    };

    const formatCardNumber = (number) => {
        return number.replace(/(.{4})/g, '$1 ').trim();
    };

    return (
        <div className="cards-page">
            <div className="cards-header">
                <h1>Mis Tarjetas</h1>
                <p>Administra tus métodos de pago</p>
            </div>

            <div className="cards-container">
                {cards.map(card => (
                    <div key={card.id} className={`card-item ${card.type}`}>
                        <button className="remove-card-btn" onClick={(e) => {
                            e.stopPropagation();
                            if (window.confirm('¿Seguro que deseas eliminar esta tarjeta?')) {
                                removeCard(card.id);
                            }
                        }}>
                            <FaTimes size={12} />
                        </button>
                        <div className="card-top">
                            <div className="card-chip"></div>
                            <div className="card-type">{card.type.toUpperCase()}</div>
                        </div>
                        <div className="card-number">
                            {card.number.includes('*') ? card.number : formatCardNumber(card.number)}
                        </div>
                        <div className="card-details">
                            <div className="card-holder">
                                TITULAR
                                <span>{card.name}</span>
                            </div>
                            <div className="card-expiry">
                                EXPIRA
                                <span>{card.expiry}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {!showAddForm ? (
                <button className="add-card-btn" onClick={() => setShowAddForm(true)}>
                    <FaPlus /> Agregar Nueva Tarjeta
                </button>
            ) : (
                <form className="add-card-form" onSubmit={handleSubmit}>
                    <h3>Agregar Tarjeta</h3>

                    <div className="form-group">
                        <label>Número de Tarjeta</label>
                        <input
                            type="text"
                            name="number"
                            value={newCard.number}
                            onChange={handleInputChange}
                            placeholder="0000 0000 0000 0000"
                            maxLength="16"
                        />
                    </div>

                    <div className="form-group">
                        <label>Nombre del Titular</label>
                        <input
                            type="text"
                            name="name"
                            value={newCard.name}
                            onChange={handleInputChange}
                            placeholder="NOMBRE APELLIDO"
                            style={{ textTransform: 'uppercase' }}
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Expiración</label>
                            <input
                                type="text"
                                name="expiry"
                                value={newCard.expiry}
                                onChange={handleInputChange}
                                placeholder="MM/YY"
                                maxLength="5"
                            />
                        </div>
                        <div className="form-group">
                            <label>CVV</label>
                            <input
                                name="cvv"
                                value={newCard.cvv}
                                onChange={handleInputChange}
                                placeholder="123"
                                maxLength="3"
                                type="password"
                            />
                        </div>
                    </div>

                    <div className="form-actions">
                        <button type="button" className="btn-cancel" onClick={() => setShowAddForm(false)}>
                            Cancelar
                        </button>
                        <button type="submit" className="btn-save">
                            Guardar Tarjeta
                        </button>
                    </div>
                </form>
            )}
        </div>
    );
};

export default CardsPage;
